var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSummaryBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1282,
    height: 860,
    viewBox: "0 0 1325 931",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M297.093 673.614C267.808 609.405 251.744 539.595 251.744 466.607C251.744 372.686 278.339 284.038 325.479 205.799",
    stroke: "#0D0D0D",
    strokeWidth: 13.7167,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M541.089 904.832C460.07 869.45 390.648 812.473 340.079 741.177",
    stroke: "#0D0D0D",
    strokeWidth: 16,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M268.752 683.833C238.332 616.576 221.651 543.466 221.651 467.011C221.651 368.639 249.275 275.793 298.243 193.843",
    stroke: "#FF4412",
    strokeWidth: 23.6232,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M533.614 924.63C449.462 887.572 377.343 827.889 324.823 753.217",
    stroke: "#FF4412",
    strokeWidth: 11.4306,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M277.722 856.831C200.649 768.808 148.633 658.29 132.797 536.417",
    stroke: "#0D0D0D",
    strokeWidth: 6.85834,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M217.109 890.147C140.037 802.124 88.0202 691.606 72.1851 569.733",
    stroke: "#0D0D0D",
    strokeWidth: 6.85834,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "9.14 30.48 30.48 30.48 60.96 22.86"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M110.706 380.596C128.431 255.065 183.922 141.514 265.43 51.5555",
    stroke: "#0D0D0D",
    strokeWidth: 8.38241,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3 439.593C9.07344 281.973 66.0053 137.254 157.998 21.0664",
    stroke: "#0D0D0D",
    strokeWidth: 5.33426,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "9.14 30.48 30.48 30.48 60.96 22.86"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M406.392 145.477C465.8 84.8794 541.89 40.6888 627.222 20.3272",
    stroke: "#0D0D0D",
    strokeWidth: 5.33426,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "9.14 30.48 30.48 30.48 60.96 22.86"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M395.502 133.139C455.467 72.2829 531.709 27.5056 617.179 5.8866",
    stroke: "#FF4412",
    strokeWidth: 11.4306,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1157.11 671.728C1186.4 607.519 1202.46 537.708 1202.46 464.72C1202.46 370.799 1175.87 282.151 1128.73 203.913",
    stroke: "#0D0D0D",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M913.116 902.945C994.136 867.564 1063.56 810.586 1114.13 739.29",
    stroke: "#0D0D0D",
    strokeWidth: 11,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M887.212 878.769C968.232 843.387 1037.65 786.41 1088.22 715.113",
    stroke: "#0D0D0D",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1185.45 681.947C1215.87 614.689 1232.55 541.579 1232.55 465.124C1232.55 366.753 1204.93 273.906 1155.96 191.957",
    stroke: "#FF4412",
    strokeWidth: 17,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M920.591 922.743C1004.74 885.685 1076.86 826.002 1129.38 751.33",
    stroke: "#FF4412",
    strokeWidth: 11.4306,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1176.48 854.944C1253.56 766.922 1305.57 656.403 1321.41 534.531",
    stroke: "#0D0D0D",
    strokeWidth: 6.85834,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryBackground);
export default __webpack_public_path__ + "static/media/SummaryBackground.1cb9796032f1f2962f75c95edf9419d2.svg";
export { ForwardRef as ReactComponent };